import React from "react";

function TextSponsor({sponsor}) {
  return (
    <div style={{padding: "10px"}}>
      {sponsor.name}
    </div>
  );
}

export default TextSponsor;